import React, { ChangeEvent } from 'react'
import styled from 'styled-components'

interface RadioOption {
  label: string
  value: string | number
  backgroundColor?: string
}

interface RadioInputsProps {
  selectedValue: string | number
  className?: string
  radioOptions: RadioOption[]
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  labelStyle?: string
  disabled?: boolean
}

const RadioInputs = ({
  className = '',
  selectedValue,
  radioOptions,
  onChange,
  labelStyle = '',
  disabled = false
}: RadioInputsProps) => {
  return (
    <S.RadioInputs className={className}>
      {
        radioOptions.map(({ label, value, backgroundColor }) => {
          return (
            <S.RadioContainer key={value}>
              <S.Input
                value={value}
                type="radio"
                id={value.toString()}
                checked={value === selectedValue}
                disabled={disabled}
                {...{ onChange }}
              />
              <S.Label
                backgroundColor={backgroundColor}
                htmlFor={value.toString()}
                labelStyle={labelStyle}
                data-disabled={disabled}
              >
                {label}
              </S.Label>
            </S.RadioContainer>
          )
        })
      }
    </S.RadioInputs>
  )
}

export default RadioInputs

interface LabelProps {
  backgroundColor?: string
  labelStyle?: string
}

const S = {
  RadioInputs: styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 15px;
  `,
  RadioContainer: styled.div`
    display: flex;
    align-items: center;
  `,
  Label: styled.label.withConfig({
    shouldForwardProp: (prop) => !['labelStyle', 'backgroundColor'].includes(prop)
  })<LabelProps>`
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${({ labelStyle }) => labelStyle}
    margin-left: 5px;
    cursor: pointer;
    opacity: 1;

    &[data-disabled="true"] {
      cursor: default;
      opacity: 0.5;
    }
  `,
  Input: styled.input`
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  `
}
